import { ConfigProvider } from "antd"
import "./App.css"
import { Navigator } from "./routers/Navigator"

function App() {
  return (
    <ConfigProvider
      theme={{
        token: {
          paddingLG: 10,
          colorBgMask: "rgba(0, 0, 0, 0.07)",
          boxShadow: "none",
          fontFamily: "Google Sans",
        },
        components: {
          Typography: {
            titleMarginBottom: "0",
          },
          Table: {
            // borderRadiusLG: 10,
            // borderRadiusOuter: 10,
            // borderRadiusSM: 10,
            // borderRadius: 10,
            // headerBorderRadius: 10,
          },
        },
      }}
    >
      <Navigator />
    </ConfigProvider>
  )
}

export default App
